import gql from "graphql-tag";

export const SEARCH_AUDIT_RECORD = gql`
  query searchAuditRecords(
    $user: String
    $recordName: String
    $recordTypes: [String]
    $actions: [String]
    $toDateTime: String
    $fromDateTime: String
    $pageNumber: Int
    $rowsPerPage: Int
  ) {
    searchAuditRecords(
      searchCondition: {
        user: $user
        recordName: $recordName
        recordTypes: $recordTypes
        actions: $actions
        fromDateTime: $fromDateTime
        toDateTime: $toDateTime
      }
      pageNumber: $pageNumber
      rowsPerPage: $rowsPerPage
    ) {
      statusCode
      message
      data
    }
  }
`;

export const GET_AUDIT_BY_ENTITY_ID = gql`
  query getEntityAuditRecords(
    $user: String
    $actions: [String]
    $toDateTime: String
    $fromDateTime: String
    $pageNumber: Int
    $rowsPerPage: Int
    $entityId: Int!
  ) {
    getEntityAuditRecords(
      searchCondition: {
        user: $user
        actions: $actions
        fromDateTime: $fromDateTime
        toDateTime: $toDateTime
        entityId: $entityId
      }
      pageNumber: $pageNumber
      rowsPerPage: $rowsPerPage
    ) {
      statusCode
      message
      data
    }
  }
`;
